<template>
  <b-alert
          variant="danger"
          class="m-5 text-center"
          show
  >Votre compte e-learning est inaccessible, merci de contacter votre centre.</b-alert>
</template>

<script>
import Layout from "@/views/Layout";
import VueFormGenerator from "@triotech/vue-core/src/vendor/vue-form-generator";
import ChangePassword from "@/components/change-password";
import RgpdCard from "@/components/rgpd-card";

export default {
  name: "Elearning",
  components: {
    Layout,
    ChangePassword,
    RgpdCard,
    "vue-form-generator": VueFormGenerator.component,
  },

};
</script>

<style lang="scss" scoped>
@import "~@/scss/vars";

/deep/ .vue-form-generator {
  > div {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;

    .form-group {
      flex: 1;
      flex-basis: calc(50% - 20px);
      margin: 0 10px;

      .form-control,
      .multiselect {
        max-width: 70%;

        .multiselect__placeholder {
          color: $dark-grey;
        }

        &[readonly] {
          color: $dark-grey;
          background-color: $light-grey;
        }

        &.multiselect--disabled {
          background-color: $light-grey;
          opacity: 1;

          .multiselect__select,
          .multiselect__tags {
            background-color: $light-grey;
          }
        }
      }
    }
  }

  &.change-password-form {
    .form-group {
      flex-basis: calc(33% - 20px);

      .form-control {
        width: 80% !important;
        max-width: 80% !important;
      }
    }
  }
}

@include media-breakpoint-down(md) {
  /deep/ .vue-form-generator {
    > div {
      .form-group {
        flex-basis: 100%;

        .form-control,
        .multiselect {
          width: 100% !important;
          max-width: 100% !important;
        }
      }
    }

    &.change-password-form {
      .form-group {
        flex-basis: 100%;

        .form-control,
        .multiselect {
          width: 100% !important;
          max-width: 100% !important;
        }
      }
    }
  }
}
</style>
